import axios from 'utils/axios';

// The profile dropdown only needs the organizations list, but /api/account/me is
// the one endpoint that reports it (grants are redis-cached server-side, so the
// extra payload is cheap). Callers take the list and discard the rest — nothing
// here writes into account state.
export async function fetchAccountOrganizations() {
    const response = await axios.get('/api/account/me');
    return response.data.organizations || [];
}
